import Andaman from "./Images/andaman.jpg";
import Gangtok from "./Images/gangtok.jpg";
import Odissa from "./Images/odissa.jpg";
import Goa from "./Images/goa.jpg";
import Jammu from "./Images/kashmir.jpg";
import Kerala from "./Images/kerala.jpg";
import Leh from "./Images/leh.jpg";
import Meghalya from "./Images/meghalya.jpg";
import Mumbai from "./Images/mumbai.jpg";
import Ooty from "./Images/ooty.jpg";
import Rajasthan from "./Images/rajasthan.jpg";
import Uttarakhand from "./Images/uttarakhand.jpg";
import Img_exoticandaman_exotic_andaman_thumb_image_0_jpg from "./Images/exotic-andaman_exotic-andaman-thumb-image-0.jpg";
import Img_exoticandaman_exotic_andaman_thumb_image_1_jpg from "./Images/exotic-andaman_exotic-andaman-thumb-image-1.jpg";
import Img_exoticandaman_exotic_andaman_thumb_image_2_jpeg from "./Images/exotic-andaman_exotic-andaman-thumb-image-2.jpeg";
import Img_gangtoktour_gangtok_tour_thumb_image_0_jpeg from "./Images/gangtok-tour_gangtok-tour-thumb-image-0.jpeg";
import Img_gangtoktour_gangtok_tour_thumb_image_1_jpeg from "./Images/gangtok-tour_gangtok-tour-thumb-image-1.jpeg";
import Img_gangtoktour_gangtok_tour_thumb_image_2_jpeg from "./Images/gangtok-tour_gangtok-tour-thumb-image-2.jpeg";
import Img_gangtoktour_gangtok_tour_thumb_image_3_jpg from "./Images/gangtok-tour_gangtok-tour-thumb-image-3.jpg";
import Img_gloriousorissatour_glorious_orissa_tour_thumb_image_0_jpg from "./Images/glorious-orissa-tour_glorious-orissa-tour-thumb-image-0.jpg";
import Img_gloriousorissatour_glorious_orissa_tour_thumb_image_1_jpeg from "./Images/glorious-orissa-tour_glorious-orissa-tour-thumb-image-1.jpeg";
import Img_gloriousorissatour_glorious_orissa_tour_thumb_image_2_jpg from "./Images/glorious-orissa-tour_glorious-orissa-tour-thumb-image-2.jpg";
import Img_gloriousorissatour_glorious_orissa_tour_thumb_image_3_jpg from "./Images/glorious-orissa-tour_glorious-orissa-tour-thumb-image-3.jpg";
import Img_goatour_goa_tour_thumb_image_1_jpg from "./Images/goa-tour_goa-tour-thumb-image-1.jpg";
import Img_goatour_goa_tour_thumb_image_2_jpg from "./Images/goa-tour_goa-tour-thumb-image-2.jpg";
import Img_goatour_goa_tour_thumb_image_3_jpg from "./Images/goa-tour_goa-tour-thumb-image-3.jpg";
import Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_0_jpg from "./Images/jammu-kashmir-tour_jammu-kashmir-tour-thumb-image-0.jpg";
import Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_1_webp from "./Images/jammu-kashmir-tour_jammu-kashmir-tour-thumb-image-1.webp";
import Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_2_jpg from "./Images/jammu-kashmir-tour_jammu-kashmir-tour-thumb-image-2.jpg";
import Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_3_jpg from "./Images/jammu-kashmir-tour_jammu-kashmir-tour-thumb-image-3.jpg";
import Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_0_jpeg from "./Images/kerala-backwaters-tour_kerala-backwaters-tour-thumb-image-0.jpeg";
import Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_1_jpeg from "./Images/kerala-backwaters-tour_kerala-backwaters-tour-thumb-image-1.jpeg";
import Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_2_jpg from "./Images/kerala-backwaters-tour_kerala-backwaters-tour-thumb-image-2.jpg";
import Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_3_jpg from "./Images/kerala-backwaters-tour_kerala-backwaters-tour-thumb-image-3.jpg";
import Img_lehladakhtour_leh_ladakh_tour_thumb_image_0_jpeg from "./Images/leh-ladakh-tour_leh-ladakh-tour-thumb-image-0.jpeg";
import Img_lehladakhtour_leh_ladakh_tour_thumb_image_1_jpg from "./Images/leh-ladakh-tour_leh-ladakh-tour-thumb-image-1.jpg";
import Img_lehladakhtour_leh_ladakh_tour_thumb_image_2_jpg from "./Images/leh-ladakh-tour_leh-ladakh-tour-thumb-image-2.jpg";
import Img_lehladakhtour_leh_ladakh_tour_thumb_image_3_jpeg from "./Images/leh-ladakh-tour_leh-ladakh-tour-thumb-image-3.jpeg";
import Img_meghalayatour_meghalaya_tour_thumb_image_0_jpeg from "./Images/meghalaya-tour_meghalaya-tour-thumb-image-0.jpeg";
import Img_meghalayatour_meghalaya_tour_thumb_image_1_jpeg from "./Images/meghalaya-tour_meghalaya-tour-thumb-image-1.jpeg";
import Img_meghalayatour_meghalaya_tour_thumb_image_2_jpg from "./Images/meghalaya-tour_meghalaya-tour-thumb-image-2.jpg";
import Img_meghalayatour_meghalaya_tour_thumb_image_3_jpg from "./Images/meghalaya-tour_meghalaya-tour-thumb-image-3.jpg";
import Img_mumbaitour_mumbai_tour_thumb_image_0_jpg from "./Images/mumbai-tour_mumbai-tour-thumb-image-0.jpg";
import Img_mumbaitour_mumbai_tour_thumb_image_1_jpeg from "./Images/mumbai-tour_mumbai-tour-thumb-image-1.jpeg";
import Img_mumbaitour_mumbai_tour_thumb_image_2_jpg from "./Images/mumbai-tour_mumbai-tour-thumb-image-2.jpg";
import Img_mumbaitour_mumbai_tour_thumb_image_3_jpg from "./Images/mumbai-tour_mumbai-tour-thumb-image-3.jpg";
import Img_ootytour_ooty_tour_thumb_image_0_jpeg from "./Images/ooty-tour_ooty-tour-thumb-image-0.jpeg";
import Img_ootytour_ooty_tour_thumb_image_1_jpg from "./Images/ooty-tour_ooty-tour-thumb-image-1.jpg";
import Img_ootytour_ooty_tour_thumb_image_2_jpg from "./Images/ooty-tour_ooty-tour-thumb-image-2.jpg";
import Img_ootytour_ooty_tour_thumb_image_3_jpeg from "./Images/ooty-tour_ooty-tour-thumb-image-3.jpeg";
import Img_uttarakhandtour_uttarakhand_tour_thumb_image_1_jpg from "./Images/uttarakhand-tour_uttarakhand-tour-thumb-image-1.jpg";
import Img_uttarakhandtour_uttarakhand_tour_thumb_image_2_jpg from "./Images/uttarakhand-tour_uttarakhand-tour-thumb-image-2.jpg";
import Img_uttarakhandtour_uttarakhand_tour_thumb_image_3_jpg from "./Images/uttarakhand-tour_uttarakhand-tour-thumb-image-3.jpg";

export const domesticPackages = [
  {
    id: "exotic-andaman",
    image: Andaman,
    name: "Exotic Andaman",
    location: "India",
    about:
      "Experience the exotic charm of the Andaman Islands with custom travel packages featuring stunning beaches, thrilling water sports, and serene escapes for all types of travelers.",
    duration: "3 Nights & 4 Days",
    price: "16,450",
    images: [
      Img_exoticandaman_exotic_andaman_thumb_image_0_jpg,
      Img_exoticandaman_exotic_andaman_thumb_image_1_jpg,
      Img_exoticandaman_exotic_andaman_thumb_image_2_jpeg,
    ],
    summary:
      "", inclusions: [

      ],
    itinerary: [

    ],
    exclusion: [

    ],
  },
  {
    id: "gangtok-tour",
    image: Gangtok,
    name: "Gangtok Tour",
    location: "Sikkim, India",
    about:
      "Embark on a scenic Gangtok tour to experience the serene beauty of the Himalayas, vibrant monasteries, and local culture, all while enjoying breathtaking views.",
    duration: "4 Nights & 5 Days",
    price: "14,999",
    images: [
      Img_gangtoktour_gangtok_tour_thumb_image_0_jpeg,

      Img_gangtoktour_gangtok_tour_thumb_image_1_jpeg,
      Img_gangtoktour_gangtok_tour_thumb_image_2_jpeg,
      Img_gangtoktour_gangtok_tour_thumb_image_3_jpg,

    ],
    summary:
      "In Gangtok, be captivated by the enchanting allure of Tsomgo Lake and the mystical aura of Baba Mandir, each holding their own unique mysteries and captivating facts. Meanwhile, Darjeeling, hailed as the \"Queens of Hills,\" unveils its majestic valleys, meandering rivers, and the emerald embrace of lush green tea gardens. Picture yourself in the midst of these breathtaking vistas, the cool breeze caressing your cheeks as you sip on a cup of freshly brewed tea from the very gardens that surround you. This is not just a tour; it's an opportunity to step into a world where nature's wonders come alive and every moment becomes a cherished memory. Don't just imagine it—live it!",
    inclusions: [
      "Breakfast (from Day 2 to Last Day as per itinerary)",
      "Vehicle: Hatchback/ SUV (As per group Size)",
      "Accommodation in Standard Hotel (Customization Possible on Request)",
      "Permits, Tolls, Fuel charges, Parking charges",
      "Driver Allowances",
      "Highly experienced driver.",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Arrival in Gangtok",
        desc: "Upon your arrival, the driver will transfer you from Bagdogra Airport/VEGA Circle to your hotel in Gangtok. You can stop at Kalimpong where you can go rafting in the Teesta River (at your own expense). Continue to Gangtok and check into your hotel. Post check-in, the remaining day is yours to enjoy and rejuvenate. You can explore MG Marg in the evening and shop for some unique souvenirs.",
      },
      {
        day: "Day 02",
        title: "Gangtok Tour",
        desc: "The driver will pick you up from your hotel and take you on a sightseeing tour of Gangtok. Visit the famous Tsomgo Lake aka Changu Lake, situated at an elevation of 3,753 m, and admire the scenic beauty of the surroundings. Head towards the holy Baba Mandir and get to know about the history of this temple. You can also visit Nathula Pass, one of the most crucial passes on Indio-China border (at your own expense). Have an overnight stay in Gangtok.",
      },
      {
        day: "Day 03",
        title: "Gangtok to Darjeeling",
        desc: "Check-out from your hotel after which the driver will pick you up and take you to Darjeeling. Pass through the scenic landscapes and marvel at the panoramic snow-covered Himalayan peaks & tea gardens. Once you check in at the hotel, the remaining day is yours to enjoy and rejuvenate. You can explore the bustling Mall Road in Darjeeling and shop for some unique souvenirs.",
      },
      {
        day: "Day 04",
        title: "Darjeeling Sightseeing Tour",
        desc: "The driver will pick you up from your hotel & take you on a sightseeing tour of Darjeeling. Reach the top of Tiger Hill & enjoy views of Mt. Kanchenjunga as the sun rises. Admire the beauty of Batasia Loop. Visit Ghoom Monastery home to a 15-foot-high Maitreya Buddha statue. Explore the Himalayan Mountaineering Institute, Darjeeling Zoo & Tenzing Rock. Visit tea estates, Tibetan Center & Peace Pagoda. Have an overnight stay in Darjeeling.",
      },
      {
        day: "Day 05",
        title: "Departure",
        desc: "Pack your bags and check out from your hotel in Darjeeling. The driver will pick you up from the hotel and take you to Bagdogra Airport (IXB)/VEGA Circle in Siliguri where your exhilarating 5-day tour will come to an end.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "glorious-orissa-tour",
    image: Odissa,
    name: "Glorious Orissa Tour",
    location: "Orissa, India",
    about:
      "Uncover the treasures of Orissa with a tour that takes you through historic temples, lush landscapes, and serene beaches, offering a unique cultural and spiritual journey.",
    duration: "1 Night & 2 Days",
    price: "12,999",
    images: [
      Img_gloriousorissatour_glorious_orissa_tour_thumb_image_0_jpg,
      Img_gloriousorissatour_glorious_orissa_tour_thumb_image_1_jpeg,
      Img_gloriousorissatour_glorious_orissa_tour_thumb_image_2_jpg,
      Img_gloriousorissatour_glorious_orissa_tour_thumb_image_3_jpg,
    ],
    summary:
      "If you’re planning a brief trip to Orissa, this brief 1 night 2 days Orissa tour package promises to rejuvenate you to the core. This brief holiday in Orissa will give you a lot of insight about the religious and environmental significance that this state holds. This Orissa tour package from Mumbai, Delhi, Kolkata and other major Indian cities serves as the best way to explore Bhubaneshwar, Puri and Konark attractions in a short period of time, yet in a well-planned manner.",
    inclusions: [
      "Meal Plan for Hotel: Breakfast",
      "GST/VAT/ Service Charges",
      "Bhubaneshwar Toll, Parking & Driver Allowance",
      "Private Cab transfers",
      "Airport/ Railway Station Transfers",
      "Accommodation on twin sharing basis",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Bhubaneshwar: Welcome to Orissa",
        desc: "The sparkling start to your Orissa tour in Bhubaneshwar. As you arrive at the airport/railway station in Bhubaneswar, you will be received by the agent’s representative who will also assist you in getting transferred to your hotel in Bhubaneshwar. Post arrival, check in to the hotel and then relax for a while to get over with the travel fatigue. Later, set out for a journey off to Puri via Dhauli giri and witness the amazing attractions including famous temples and monuments pass by. You will visit the famous Jagannath Temple followed by a visit to the Sun Temple in Konark. As the dusk falls, you will be transferred to your hotel back in Bhubaneswar for an overnight stay.",
      },
      {
        day: "Day 02",
        title: "Bhubaneswar: Departure",
        desc: "The 2-day Orissa tour ends today Wake up to a wholesome breakfast at the hotel before you check out from the hotel and get ready to start your onward journey back home. You will be transferred to the nearest airport/railway station/ bus station.",
      },
    ],
    exclusion: [
      "Any meals other than those mentioned above.",
      "5 % GST Extra.",
      "Any portage at airports and hotels, tips, insurance, wine, mineral water, telephone charges, and all items of personal nature.",
      "Any services not specifically mentioned in the inclusions.",
      "Expenses caused by factors beyond our control like roadblocks, vehicle malfunctions, political disturbances etc.",
    ],
  },
  // {
  //   id: "goa-tour",
  //   image: Goa,
  //   name: "Goa Tour",
  //   location: "Goa, India",
  //   about:
  //     "Experience the vibrant charm of Goa with a tour that combines golden beaches, lively nightlife, and rich Portuguese heritage, perfect for both relaxation and adventure.",
  //   duration: "3 Nights & 4 Days",
  //   price: "13,500",
  //   images: [
  //     Goa,
  //     Img_goatour_goa_tour_thumb_image_1_jpg,
  //     Img_goatour_goa_tour_thumb_image_2_jpg,
  //     Img_goatour_goa_tour_thumb_image_3_jpg,
  //   ],
  //   summary:
  //     "The land of vibrant colors, rich heritage, scenic locations, majestic lakes, beautiful palaces, golden sands and everything else in between, Rajasthan with its royal essence welcomes you with all its heart. With this tour package experience the transition from rich greenery and serene lakes in Jaipur & Udaipur to the dry deserts in Jodhpur and Jaisalmer.",
  //   inclusions: [
  //     "Airport / Railway Station pick up and drop as per your flight / train timings",
  //     "Comfortable and hygienic Vehicle (SUV / Sedan / Tempo Traveler) as per the group size",
  //     "Stay on a double (for couples & special requests) and triple sharing basis in hotels / camps",
  //     "Breakfast (from Day 2 to Last Day as per itinerary)",
  //     "Driver night charges & allowances, toll tax, parking charges, etc.",
  //     "Experienced driver for the entire journey",
  //     "Sightseeing as per itinerary",
  //   ],
  //   itinerary: [
  //     {
  //       day: "Day 01",
  //       title: "Arrival",
  //       desc: "Welcome to your destination. You are welcome & picked up by your Chauffer from the main exit of the airport/ railway station, waiting outside for you with the placard of your name and transferred to the hotel in your private chauffer driven car. Proceed for a city sightseeing tour.",
  //     },
  //     {
  //       day: "Day 02",
  //       title: "Sightseeing",
  //       desc: "The driver will pick you up from your hotel & take you on a city tour. Visit historical sites adorned with intricate architecture and rich heritage. Continue to forts, boasting large cannons, & visit other spots offering stunning city views. Capture the essence of Indian tradition. Later, return to the hotel.",
  //     },
  //     {
  //       day: "Day 03",
  //       title: "More Sightseeing",
  //       desc: "Another day of exploring the beautiful landscapes and cultural heritage. Visit local markets and famous temples. Enjoy the local cuisine and interact with the locals to get a feel of the place. Return to hotel for overnight stay.",
  //     },
  //     {
  //       day: "Day 04",
  //       title: "Departure",
  //       desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel and take you to the Railway Station or the airport, from where you will return home.",
  //     },
  //   ],
  //   exclusion: [
  //     "Any Meals other than inclusions",
  //     "Flights",
  //     "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
  //     "Anything which is not included in the package.",
  //     "Travel insurance",
  //     "5% GST Extra",
  //   ],
  // },
  {
    id: "jammu-kashmir-tour",
    image: Jammu,
    name: "Jammu Kashmir Tour",
    location: "Jammu & Kashmir, India",
    about:
      "Explore the enchanting landscapes of Jammu and Kashmir, with its pristine valleys, picturesque lakes, and historic temples, offering an unforgettable blend of natural.",
    duration: "3 Nights & 4 Days",
    price: "12,740",
    images: [
      Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_0_jpg,
      Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_1_webp,
      Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_2_jpg,
      Img_jammukashmirtour_jammu_kashmir_tour_thumb_image_3_jpg,
    ],
    summary:
      "Welcome to our Kashmir tour package overview! Kashmir, often referred to as \"Paradise on Earth,\" is a picturesque region in the northern part of India. It is known for its breathtaking natural beauty, serene landscapes, lush valleys, snow-capped mountains, and enchanting lakes. Our tour package aims to give you an unforgettable experience of this mesmerizing destination. Here's an overview of what you can expect",
    inclusions: [
      "Accommodation in Hotel sharing basis - 3*",
      "1 - Deluxe room with complimentary services. Breakfast complimentary",
      "2 Nights accommodation in Srinagar.",
      "1 Night accommodation in Gulmarg.",
      "A/C Cottage/Room at Agatti for 3N & 4D",
      "Pickup & Drop from Srinagar Airport/Railway Station. Sightseeing Tour by Swift or simlar as per the itinerary.",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Arrival in Srinagar",
        desc: "Arrive in Srinagar, the summer capital of Jammu and Kashmir, and check-in at your hotel or houseboat on Dal Lake. After some rest, head to the famous Mughal Gardens, such as Nishat Bagh and Shalimar Bagh, known for their stunning landscapes, fountains, and vibrant flowerbeds. In the evening, enjoy a shikara (traditional boat) ride on Dal Lake, witnessing the sunset and the charming floating gardens. You can explore the local markets like Lal Chowk and Residency Road for shopping and trying some traditional Kashmiri cuisine.",
      },
      {
        day: "Day 02",
        title: "Srinagar Sightseeing",
        desc: "Start the day with a visit to the Shankaracharya Temple, located on a hilltop, offering panoramic views of Srinagar. Next, visit the Jamia Masjid, an architectural marvel and a significant religious site for Muslims in Srinagar. Explore the old city and visit the Hazratbal Shrine, situated on the banks of Dal Lake and known for its religious importance. If time permits, you can take a short trip to the Pari Mahal or Chashme Shahi for more beautiful views and serene surroundings.",
      },
      {
        day: "Day 03",
        title: "Gulmarg Excursion",
        desc: "Leave Srinagar and drive to Gulmarg, a picturesque hill station known for its meadows and skiing opportunities during winters. Once in Gulmarg, take the Gondola ride, one of the highest cable cars in the world, to reach Apharwat Peak, where you can enjoy breathtaking views of the snow-capped mountains. If you visit in the summer, you can take a leisurely walk through the colorful meadows and enjoy pony rides. In the evening, return to Srinagar and spend the night in your hotel.",
      },
      {
        day: "Day 04",
        title: "Departure",
        desc: "Depending on your departure time, you can do some last-minute shopping or visit any attraction you might have missed before heading to the airport for your journey back home",
      },
    ],
    exclusion: [
      "Any meals other than those mentioned above.",
      "5 % GST Extra.",
      "Any portage at airports and hotels, tips, insurance, wine, mineral water, telephone charges, and all items of personal nature.",
      "Any services not specifically mentioned in the inclusions.",
      "Expenses caused by factors beyond our control like roadblocks, vehicle malfunctions, political disturbances etc.",
    ],
  },
  {
    id: "kerala-backwaters-tour",
    image: Kerala,
    name: "Kerala Backwaters Tour",
    location: "Kerala, India",
    about:
      "Experience the tranquility of Kerala's backwaters, gliding through peaceful canals, lush greenery, and picturesque villages for a unique and rejuvenating journey.",
    duration: "4 Nights & 5 Days",
    price: "25,500",
    images: [
      Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_0_jpeg,
      Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_1_jpeg,
      Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_2_jpg,
      Img_keralabackwaterstour_kerala_backwaters_tour_thumb_image_3_jpg,
    ],
    summary:
      "Welcome to our Kerala tour package overview! Kerala, often referred to as \"Paradise on Earth,\" is a picturesque region in the northern part of India (correction: Southern India). It is known for its breathtaking natural beauty, serene landscapes, lush valleys, and enchanting lakes. Our tour package aims to give you an unforgettable experience of this mesmerizing destination. Here's an overview of what you can expect",
    inclusions: [
      "Welcome Drink.",
      "Room Decoration",
      "Honeymoon Cake.",
      "Pickup & Drop from Cochin Airport /Railway Station. Sightseeing Tour by Swift Dzire/FERRY/JETTY Indigo or Similar as per the itinerary.",
      "Air & Train fare/Bus.",
      "Club entry & bonfire or parties are subject to availability.",
      "Heater Charges per night. Any adventure activities.",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Munnar Tea Gardens & Lakes",
        desc: "Morning: Start your day by visiting the breathtaking tea gardens of Munnar. You can take a guided tour of the tea plantation and learn about the tea-making process. Afternoon: After lunch, head to the Mattupetty Dam and enjoy a boat ride on the emerald green waters. You can also visit the nearby Echo Point, where you can hear your voice echoing back. Evening: As the day ends, visit the famous Kundala Lake, which offers stunning views of the surrounding hills. You can also visit the Top Station viewpoint to witness the beautiful sunset. Top rated restaurants: Rapsy Restaurant, Saravana Bhavan, and Munnar Inn Restaurant.",
      },
      {
        day: "Day 02",
        title: "Alleppey Backwaters",
        desc: "Morning: Explore the backwaters of Alleppey by taking a houseboat tour. You can watch the serene landscapes and witness the daily lives of locals.. Afternoon: After lunch, visit the famous Marari Beach, which is famous for its white sands and crystal clear waters. Evening: Take a stroll in the Alleppey town, which is known for its colonial architecture and local markets. Top rated restaurants: Mushroom, Thaff Delicacy, and Halais Restaurant.",
      },
      {
        day: "Day 03",
        title: "Athirapally Waterfalls",
        desc: "Morning: Take a guided tour of the Athirapally Waterfalls, which is one of the largest waterfalls in India. Afternoon: Visit the Vazhachal Waterfalls and enjoy a picnic lunch. Evening: Take a stroll in the nearby forest and witness the flora and fauna of the region. Top rated restaurants: Kerala House Restaurant, Hotel River View, and Athirapally Green Trees.",
      },
      {
        day: "Day 04",
        title: "Kochi Sightseeing",
        desc: "Morning: Visit the historic city of Kochi and explore the Dutch Palace, which is famous for its unique architecture and murals. Afternoon: Visit the Jewish synagogue and St. Francis Church, which is the oldest European church in India. Evening: Watch the mesmerizing Kathakali dance performance or attend a classical music concert. Top rated restaurants: Kashi Art Cafe, Dal Roti, and Fort House Restaurant.",
      },
      {
        day: "Day 05",
        title: "Departure",
        desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel from where you will return home.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "leh-ladakh-tour",
    image: Leh,
    name: "Leh Ladakh Tour",
    location: "Leh, India",
    about:
      "Discover the rugged beauty of Leh Ladakh with a tour featuring breathtaking mountain vistas, ancient monasteries, and vibrant culture, perfect for adventure seekers.",
    duration: "4 Nights & 5 Days",
    price: "22,999",
    images: [
      Img_lehladakhtour_leh_ladakh_tour_thumb_image_0_jpeg,
      Img_lehladakhtour_leh_ladakh_tour_thumb_image_1_jpg,
      Img_lehladakhtour_leh_ladakh_tour_thumb_image_2_jpg,
      Img_lehladakhtour_leh_ladakh_tour_thumb_image_3_jpeg,
    ],
    summary:
      "Welcome to our Ladakh Tour Package overview! Ladakh, often referred to as \"Paradise on Earth,\" is a picturesque region in the northern part of India. It is known for its breathtaking natural beauty, mmountains, hills station, fresh air and enchanting lakes. Our tour package aims to give you an unforgettable expeience of this mesmerizing destination. Here's an overview of what you can expect",
    inclusions: [
      "3.09 % on total package.",
      "Train fare/ air fare.",
      "Any expenses of personal nature such as tips, laundry, telephone calls, fax etc.",
      "Entrance fees for monument, monasteries and museums.",
      "Any kind of drinks (alcoholic, mineral, aerated).",
      "Anything not specifically mentioned under the head Inclusions",
      "Any expenses incurred on extra transport, apart from the ones - covered in the package.",
      "Room service and additional meals.",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Arrival at Leh",
        desc: "On arrival, pickup from the airport and transfer to hotel. After welcoming at the hotel, enjoy tea and coffee Later, acclimatize yourself to the low atmospheric pressure because of the high altitude of Ladakh. In the late afternoon, drive to Shanti Stupa. Overnight stay at the hotel.",
      },
      {
        day: "Day 02",
        title: "Leh to Likir and Alchi in Sham Valley",
        desc: "After breakfast, drive to Likir Monastery. En route visit Phater Sahib, Magnetic Hill, and the Indus and Zansker Sangam. Continue the drive to Alchi Monastery. Be back to Leh by evening. Overnight stay at the hotel in Leh.",
      },
      {
        day: "Day 03",
        title: "Leh to Thiksey and Pangong Lake",
        desc: "After breakfast, drive to Pangong Lake (the biggest high altitude lake in Asia) Enjoy the turquoise color panoramic lake and the magnificent mountains. Overnight stay at the camp.",
      },
      {
        day: "Day 04",
        title: "Pangong to Leh",
        desc: "After breakfast, drive back to Leh. En route visit Thiksey Monastery and Shey Monastery. Overnight stay at the hotel.",
      },
      {
        day: "Day 05",
        title: "Departure",
        desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel from where you will return home.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "meghalaya-tour",
    image: Meghalya,
    name: "Meghalaya Tour",
    location: "Meghalaya, India",
    about:
      "Embark on a Meghalaya tour to witness breathtaking hills, pristine waterfalls, and the famous living root bridges, offering a perfect blend of nature and culture.",
    duration: "3 Nights & 4 Days",
    price: "21,499",
    images: [
      Img_meghalayatour_meghalaya_tour_thumb_image_0_jpeg,
      Img_meghalayatour_meghalaya_tour_thumb_image_1_jpeg,
      Img_meghalayatour_meghalaya_tour_thumb_image_2_jpg,
      Img_meghalayatour_meghalaya_tour_thumb_image_3_jpg,
    ],
    summary:
      "Separating Assam from Bangladesh, Meghalaya is also known as the abode of clouds. It is a cool and refreshing mountain state situated on dramatic rocky cliffs. The beautiful Meghalaya comprises of two places, namely Cherrapunji and Mawsynram, that are among the wettest places on earth. A 4 days 3 Nights Meghalaya honeymoon package provides a romantic trip to the most impressive waterfalls and longest caves carved out by the heavy rainfall in Meghalaya.",
    inclusions: [
      "Assistance on Arrival & Departure",
      "Exclusive vehicle for transfers",
      "Meal (Breakfast)",
      "Driver's Allowance",
      "Accommodation on Twin Sharing Basis",
      "Sightseeing as per itinerary",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Meghalaya : Arrival in Shillong",
        desc: "On reaching the Shillong Airport, agent representative and get transferred to your hotel in Shillong. On your way, visit the Umiam Lake and enjoy the cold sparkling water. As you arrive, check in at your hotel and spend some quality indoors. The first day of your Meghalaya honeymoon package takes you to visit Police Bazar in evening, the main commercial hub of Shillong. After shopping for some souvenirs and other special products, return to your hotel for a romantic night.",
      },
      {
        day: "Day 02",
        title: "Cherrapunji Sightseeing",
        desc: "Spend the second day of your Meghalaya honeymoon sightseeing at various secluded waterfalls and caves. After having a delicious breakfast at your hotel, check out and leave for Cherrapunji. On your way, visit the Majestic Shillong peak for scenic views and enjoy the charming Elephanta Falls. Proceed to stop at the Mawkdok valley for breathtaking views of mighty mountains. Your Meghalaya honeymoon tour takes you to the magical waterfalls and mystic caves of Cherrapunji today including the Nohkalikai Falls, Seven sisters Falls, Dainthlen Falls and Mawsmai caves. After a delicious authentic lunch visits the Awrah cave. After an exciting day, check in at your hotel and spend a cozy night there.",
      },
      {
        day: "Day 03",
        title: "Shillong and Guwahati: Sightseeing and Departure",
        desc: "Sightseeing Breakfast Departure Make adorable memories to take home with you as you explore the natural wonders and history on the last day of your Meghalaya honeymoon tour! Right after a satiating breakfast, check out from the hotel and leave for sightseeing in Shillong. Visit the Don Bosco Museum, mawphlang sacred forest, and the laitlum Canyon. Drive towards Guwahati as you prepare to bid farewell to this magical pocket of India. Reach Guwahati and make your last visit to the Kamakhya Temple. Afterward, get transferred to the Guwahati Railway Station and head home with this lovely start to your married life. Your Meghalaya honeymoon package terminates here.",
      },
      {
        day: "Day 04",
        title: "Departure",
        desc: "It’s time now to say goodbye to our travel companions. Let’s stay in touch with each other through email, phone, WhatsApp, Facebook, Instagram and meet again on yet another memorable tour. See you all!! Tour Guests will proceed to airport as per their schedule flight and start their return journey back home Tour Concludes.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "mumbai-tour",
    image: Mumbai,
    name: "Mumbai Tour",
    location: "Maharashtra, India",
    about:
      "Experience the vibrant energy of Mumbai with a tour that takes you to iconic landmarks like the Gateway of India, Marine Drive, and Elephanta Caves, blending history, culture.",
    duration: "2 Nights & 3 Days",
    price: "13,999",
    images: [
      Img_mumbaitour_mumbai_tour_thumb_image_0_jpg,
      Img_mumbaitour_mumbai_tour_thumb_image_1_jpeg,
      Img_mumbaitour_mumbai_tour_thumb_image_2_jpg,
      Img_mumbaitour_mumbai_tour_thumb_image_3_jpg,
    ],
    summary:
      "Fondly known as the city of dreams, your Mumbai tour package will unravel this spectacular juxtaposition of hope and despair, glitz and drab, modernism and heritage. Home to Bollywood, Mumbai is a city that never sleeps, literally! From hustlers and dreamers to billionaires and superstars; from tribes of fishermen to slum dwellers, Mumbai is replete with people who have some mind-boggling stories to narrate. And since the city soaks in everything, making it its own, Mumbai has turned into a melting pot of different traditions and cultures.",
    inclusions: [
      "(Honeymoon Inclusions Free)",
      "Welcome Drink.",
      "Sightseeing at all the mentioned places",
      "Fuel",
      "Parking",
      "Room on Double Sharing",
      "Pickup and drop From Nearest Airport/Railway station",
      "Transportation by individual Cab",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Welcome to Mumbai: Arrival",
        desc: "You have to arrive at Mumbai airport whether Domestic or International it’s your choice or else you can arrive at the railway station. Get greeted by our representatives and they will transfer you to your hotel within a fraction of time. Upon your arrival, you can check in at the hotel and unpack all your essential stuff and belongings. Settle down with proper refreshment. Spend some entertaining time at leisure.",
      },
      {
        day: "Day 02",
        title: "Spend some amazing time in Mumbai: Sightseeing",
        desc: "Have your breakfast and get prepared for a full day excursion tour. Start your day with Elephanta Caves and you can go for paid guides who can help you to make your tour more interesting. You can cover Gateway of India and the very famous Taj Hotel. You can further proceed to the Prince of Wales Museum and en route to Mumbai High Court and University.",
      },
      {
        day: "Day 03",
        title: "Departure",
        desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel from where you will return home.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "ooty-tour",
    image: Ooty,
    name: "Ooty Tour",
    location: "Tamil Nadu, India",
    about:
      "Experience the scenic beauty of Ooty with its lush tea gardens, serene lakes, and cool hill station charm, perfect for a relaxing getaway. Discover the tranquil hill station of Ooty.",
    duration: "3 Nights & 4 Days",
    price: "17,899",
    images: [
      Img_ootytour_ooty_tour_thumb_image_0_jpeg,
      Img_ootytour_ooty_tour_thumb_image_1_jpg,
      Img_ootytour_ooty_tour_thumb_image_2_jpg,
      Img_ootytour_ooty_tour_thumb_image_3_jpeg,
    ],
    summary:
      "Embark on a family adventure with our Ooty Tour Package, where joy unfolds in every moment. From the enchanting toy train rides to exploring nature wonders in Botanical Gardens and the picturesque tea gardens of Coonoor, where gardens stretch like green carpets, Sim Park becomes a playground for both young and young-at-heart. Choose our package for a journey that goes beyond a vacation; its a tale of laughter, discovery, and precious togetherness.",
    inclusions: [
      "Accommodation in hotels on Double or Triple Sharing",
      "Meals: Breakfast from day 2 to day 4",
      "Transportation: 1 private vehicle per traveler. Sedan, SUV, or hatchback",
      "Permits, Parking Charges, tolls, and Fuel",
      "Experienced drivers guide",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Arrival in Bangalore | Transfer from Bangalore to Ooty",
        desc: "Arrive in Bangalore where you will be welcomed by the representative. The representative will take you from Bangalore to Ooty in private transfers. Reach Ooty, check-in to your hotel and rest for sometime before going for local sightseeing. Get picked up by a representative from your hotel to proceed with sightseeing of Ooty. Your first stop will be the Ooty Lake which also offers boating amidst the serene surroundings. Next, you will head over to the Botanical Garden and get fascinated by the incredible collection of plants, trees and flowers. Retire to your hotel for an overnight stay in Ooty.",
      },
      {
        day: "Day 02",
        title: "Ooty Sightseeing | Hike up to the Doddabetta Peak",
        desc: "Wake up early in the morning and get picked up by a representative in private transfer. You will be taken on a short hike to the Doddabetta Peak to watch the enchanting sunrise. Return to your hotel and have breakfast before beginning your second day of sightseeing in Ooty. Your first stop will be the lush green Tea Plantations of Ooty where you will get to learn about the tea making process from scratch. Next, you will visit the Rose Gardens where you can relax and unwind as you stroll through the 20,000 different varieties of rose bushes. Return to your hotel for overnight stay in Ooty.",
      },
      {
        day: "Day 03",
        title: "Ooty to Coonoor Trip | Visit the beautiful Catherine Falls",
        desc: "Wake up, have breakfast and check out from your hotel. You will be transferred to Coonoor and on the way, you will stop by the Sim Park. Relax and unwind amidst the serene environment of the park before resuming your journey to Coonoor. Your next destination will be the Dolphin Nose Viewpoint which offers exquisite views of the valleys of the Nilgiris. End your day by taking a short excursion to the stunning Catherine Falls and marvel at the beauty of cascading waters. Have authentic dinner at a local restaurant.",
      },
      {
        day: "Day 04",
        title: "Departure | Return with a plethora of memories",
        desc: "Wake up, have breakfast and check out from your hotel. Get picked up by a representative from your hotel who will ensure your smooth transfer to Bangalore. Return back with a bunch full of memories to cherish a lifetime.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  {
    id: "rajasthan-tour",
    image: Rajasthan,
    name: "Rajasthan Tour",
    location: "Rajsthan, India",
    about:
      "Immerse yourself in the royal heritage of Rajasthan, exploring majestic palaces, forts, and vibrant markets in cities like Jaipur, Udaipur, and Jodhpur.",
    duration: "3 Nights & 4 Days",
    price: "16,899",
    images: [
      "https://shineairways.com/admin/assets/thumb_images/rajasthan-tour-thumb-image-1.jpeg",
      "https://shineairways.com/admin/assets/thumb_images/rajasthan-tour-thumb-image-2.jpeg",
      "https://shineairways.com/admin/assets/thumb_images/rajasthan-tour-thumb-image-3.jpeg",
    ],
    summary:
      "The land of vibrant colors, rich heritage, scenic locations, majestic lakes, beautiful palaces, golden sands and everything else in between, Rajasthan with its royal essence welcomes you with all its heart. With this tour package experience the transition from rich greenery and serene lakes in Jaipur & Udaipur to the dry deserts in Jodhpur and Jaisalmer.",
    inclusions: [
      "Airport / Railway Station pick up and drop as per your flight / train timings",
      "Comfortable and hygienic Vehicle (SUV / Sedan / Tempo Traveler) as per the group size",
      "Stay on a double (for couples & special requests) and triple sharing basis in hotels / camps",
      "Breakfast (from Day 2 to Last Day as per itinerary)",
      "Driver night charges & allowances, toll tax, parking charges, etc.",
      "Experienced driver for the entire journey",
      "Sightseeing as per itinerary",
    ],
    itinerary: [
      {
        day: "Day 01",
        title: "Arrival Udaipur",
        desc: "Welcome to City of Lakes, You are welcome & picked up by your Chauffer from the main exit of the airport/ railway station, waiting outside for you with the placard of your name and transferred to the hotel in your private chauffer driven car. Proceed for a city sightseeing tour of Udaipur. The city is built in 1559 A.D. by Maharaja Udai Singh and has been described as the most romantic city of Mewar Region on the banks of Lake Pichola and surrounded by the Hills of Aravali Mountains Range. The Aravalli Mountains is the oldest in the world after Himalayas.",
      },
      {
        day: "Day 02",
        title: "Arrival in Jaipur",
        desc: "Upon your arrival in Jaipur, the driver will pick you up from the airport/railway or bus station & take you to the hotel. Once you check in, rest for a while & get ready for sightseeing. Begin with a short stopover at Hawa Mahal & then visit Jantar Mantar, an observatory. Then admire City Palace, the royal residence, followed by a visit to Govind Dev Ji Temple and the local market in the evening. Later, return to your hotel for an overnight stay.",
      },
      {
        day: "Day 03",
        title: "Sightseeing in Jaipur",
        desc: "The driver will pick you up from your hotel & take you on a city tour of Jaipur. Visit Amer Fort, a historical site adorned with intricate architecture and rich heritage. Continue to Jaigarh Fort, boasting one of the largest cannons, & visit Nahargarh Fort, offering stunning city views. Capture the essence of Indian tradition with a photo stop at Jal Mahal (water palace). Discover the magnificence of Birla Temple, crafted with shimmering white marble. Later, return to the hotel.",
      },
      {
        day: "Day 04",
        title: "Departure",
        desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel and take you to Jaipur Railway Station or the airport, from where you will return home.",
      },
    ],
    exclusion: [
      "Any Meals other than inclusions",
      "Flights",
      "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
      "Anything which is not included in the package.",
      "Travel insurance",
      "5% GST Extra",
    ],
  },
  // {
  //   id: "uttarakhand-tour",
  //   image: Uttarakhand,
  //   name: "Uttarakhand Tour",
  //   location: "Uttarakhand, India",
  //   about:
  //     "Explore the spiritual and natural beauty of Uttarakhand, with serene hill stations, holy temples, and breathtaking landscapes in destinations like Nainital, Rishikesh.",
  //   duration: "3 Nights & 4 Days",
  //   price: "16,799",
  //   images: [
  //     Uttarakhand,
  //     Img_uttarakhandtour_uttarakhand_tour_thumb_image_1_jpg,
  //     Img_uttarakhandtour_uttarakhand_tour_thumb_image_2_jpg,
  //     Img_uttarakhandtour_uttarakhand_tour_thumb_image_3_jpg,
  //   ],
  //   summary:
  //     "The land of vibrant colors, rich heritage, scenic locations, majestic lakes, beautiful palaces, golden sands and everything else in between, Rajasthan with its royal essence welcomes you with all its heart. With this tour package experience the transition from rich greenery and serene lakes in Jaipur & Udaipur to the dry deserts in Jodhpur and Jaisalmer.",
  //   inclusions: [
  //     "Airport / Railway Station pick up and drop as per your flight / train timings",
  //     "Comfortable and hygienic Vehicle (SUV / Sedan / Tempo Traveler) as per the group size",
  //     "Stay on a double (for couples & special requests) and triple sharing basis in hotels / camps",
  //     "Breakfast (from Day 2 to Last Day as per itinerary)",
  //     "Driver night charges & allowances, toll tax, parking charges, etc.",
  //     "Experienced driver for the entire journey",
  //     "Sightseeing as per itinerary",
  //   ],
  //   itinerary: [
  //     {
  //       day: "Day 01",
  //       title: "Arrival",
  //       desc: "Welcome to your destination. You are welcome & picked up by your Chauffer from the main exit of the airport/ railway station, waiting outside for you with the placard of your name and transferred to the hotel in your private chauffer driven car. Proceed for a city sightseeing tour.",
  //     },
  //     {
  //       day: "Day 02",
  //       title: "Sightseeing",
  //       desc: "The driver will pick you up from your hotel & take you on a city tour. Visit historical sites adorned with intricate architecture and rich heritage. Continue to forts, boasting large cannons, & visit other spots offering stunning city views. Capture the essence of Indian tradition. Later, return to the hotel.",
  //     },
  //     {
  //       day: "Day 03",
  //       title: "More Sightseeing",
  //       desc: "Another day of exploring the beautiful landscapes and cultural heritage. Visit local markets and famous temples. Enjoy the local cuisine and interact with the locals to get a feel of the place. Return to hotel for overnight stay.",
  //     },
  //     {
  //       day: "Day 04",
  //       title: "Departure",
  //       desc: "Pack your bags and check out from your hotel. The driver will pick you up from the hotel and take you to the Railway Station or the airport, from where you will return home.",
  //     },
  //   ],
  //   exclusion: [
  //     "Any Meals other than inclusions",
  //     "Flights",
  //     "Personal expenses such as tips, porterage, telephone calls, rooms service, etc.",
  //     "Anything which is not included in the package.",
  //     "Travel insurance",
  //     "5% GST Extra",
  //   ],
  // },
];
